export class InsertLawyer {
    name: string;
    email: string;
}